export const FINANCIAL_REPORT_SET_DATE_RANGE =
  'FINANCIAL_REPORT/SET_DATE_RANGE';
export const FINANCIAL_REPORT_SET_STUDIOS = 'FINANCIAL_REPORT/SET_STUDIOS';
export const FINANCIAL_REPORT_GET_LABOR_EFFICIENCY =
  'FINANCIAL_REPORT/GET_LABOR_EFFICIENCY';
